import request from '../src/config/index.js'
// yanzhengma
export function getcaptcha(data) {
  return request({
    // url: '/captcha',
    url: '/share/user/captcha',
    headers: {
      isToken: false
    },
    responseType: 'arraybuffer',
    method: 'get',
    timeout: 20000
  })
}
//denglu
export function getlogin(data) {
  return request({
    url: '/login',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data,
    timeout: 20000
  })
}
export function getlogin_share(data) {
  return request({
    url: '/share/user/login',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data,
    timeout: 20000
  })
}

//退出
export function gelogout(data) {
  return request({
    // url: '/logout',
    url: '/share/user/logout',
    method: 'post',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}



//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = IYyn
// module chunks = 6